<div class="container-fluid"
    [ngClass]="page"
>
    <div class="row row-height">
        <div class="col-md-6 left-side">
            <div class="content">
                <ng-content select="[left]"></ng-content>
                <a [routerLink]="['/']" class="logo">
                    <img src="storage/branding_media/NsUTrF9NuX6ibG0MH6owr9TBerwn8bTtqmpek68D.png" alt="logo" />
                </a>
                <div class="social">
                    <ul>
                        <!-- <li>
                            <a href="https://api.whatsapp.com/send/?phone=917276595716&text=Hi&type=phone_number&app_absent=0"
                            target="_blank" class="icon-button whatsapp"><i class="fa fa-whatsapp"></i><span></span></a>
                        </li> -->
                        <!-- <li>
                            <a href="https://t.me/JioShURLBot" target="_blank" class="icon-button telegram"><i
                            class="fa fa-telegram"></i><span></span></a>
                        </li> -->
                        <li>
                            <a href="https://twitter.com/messages/compose?recipient_id=1410639908738244612&text=Hi"
                            target="_blank" class="icon-button twitter"><i class="fa fa-twitter"></i><span></span></a>
                        </li>
                        <li>
                            <a href="https://m.me/JioShURL" target="_blank" class="icon-button facebook"><i
                            class="fa fa-facebook"></i><span></span></a>
                        </li>
                        <li>
                            <a href="https://ig.me/m/jioshurl" target="_blank" class="icon-button instagram"><i
                            class="fa fa-instagram"></i><span></span></a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="col-md-6 right-side">
            <div class="content">
                <ng-content select="[form]"></ng-content>
            </div>
            <div class="footer">
                <p>© JioSh - Premium & Affordable Short URL & Bio Links Service</p>
            </div>
        </div>
    </div>
</div>